import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import GastosData from '../../Components/Admin/GastosData/GastosData';

export default function Gastos() {
    return (
        <div className="containerGrid">
            <Header />
            <section className="containerSection">
                <HeaderDash />
                <div className="container">
                    <GastosData />
                </div>
            </section>
        </div>
    );
}
